import { unslugify } from 'utils/slug'

/**
 * Finds a station from mainData by matching the slugified station parameter.
 * 
 * @param {Object} mainData - The main data object containing user and station information
 * @param {string} stationParam - The slugified station name, or the station guid, from the route parameter
 * @returns {Object|undefined} - The matching station object, or undefined if not found
 */
const parseStation = (mainData, stationParam) => {
  const {
    me: {
      stations: { items: stations },
    },
  } = mainData
  return stations.find(
    ({ id, name }) =>
      id === stationParam || name.toUpperCase() === unslugify(stationParam).toUpperCase()
  )
}

export { parseStation }
